import { render, staticRenderFns } from "./ObjectsCustomKanban.vue?vue&type=template&id=7bc9502a&scoped=true&"
import script from "./ObjectsCustomKanban.vue?vue&type=script&lang=js&"
export * from "./ObjectsCustomKanban.vue?vue&type=script&lang=js&"
import style0 from "./ObjectsCustomKanban.vue?vue&type=style&index=0&id=7bc9502a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc9502a",
  null
  
)

export default component.exports